var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.0637 238.18l38.357-38.357 206.71 206.71 206.58-206.58 38.222 38.222-244.94 244.94-244.94-244.94z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5014 0 0 1.5014 -125.36 -125.53)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.71 255.14l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.29 268.72l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.88 282.3l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.46 295.89l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.04 309.47l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.63 323.05l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.21 336.64l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.79 350.22l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.38 363.81l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.96 377.39l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.54 390.97l9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.39 261.9l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.99 275.5l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.58 289.1l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.18 302.7l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.78 316.3l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.38 329.9l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.98 343.5l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.58 357.1l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216.18 370.69l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.78 384.29l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.38 397.89l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.787 248.3l4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.92 255.51l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.34 269.09l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.75 282.68l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.17 296.26l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.58 309.85l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 323.43l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.42 337.01l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.83 350.6l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.25 364.18l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.67 377.76l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.08 391.35l-9.7155-9.7155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.24 262.28l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.64 275.87l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.04 289.47l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.44 303.07l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.84 316.67l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.24 330.27l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.65 343.87l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.05 357.47l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.45 371.07l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.85 384.67l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.25 398.27l-4.8931-4.8931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.84 248.68l-4.8931-4.8931"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5014 0 0 1.5014 -125.36 -125.53)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m259.69 107.09l-29.887 17.255 47.548 82.356c34.567 1.2688 55.909 75.364 83.863 113.04 12.163-8.3858 15.544 10.974 45.466 41.937l-146.99-254.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.97 107.09l29.887 17.255-47.548 82.356c-34.567 1.2688-55.909 75.364-83.863 113.04-12.163-8.3858-15.544 10.974-45.466 41.937l146.99-254.59z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m276.11 119.8c0.005493 15.255-12.36 27.625-27.615 27.625s-27.62-12.37-27.615-27.625c-0.005493-15.255 12.36-27.625 27.615-27.625s27.62 12.37 27.615 27.625z",
    strokeWidth: 2.235
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.76 119.8c0.004425 12.3-9.9653 22.273-22.265 22.273s-22.27-9.9733-22.265-22.273c-0.004425-12.3 9.9653-22.273 22.265-22.273s22.27 9.9733 22.265 22.273z",
    strokeWidth: 2.772
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.41e534c4945dea98a2e7ee5a0ec77717.svg";
export { ForwardRef as ReactComponent };